module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h2', {
    staticClass: "center-align"
  }, [_vm._v("Community Metric Explorer")]), _vm._v(" "), _c('p', {
    staticClass: "center-align"
  }, [_vm._v("This tool allows users to see whether data is available for evaluating the financial, human, and technical capacity of specific Alaska communities to undertake energy projects.")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s10"
  }, [_vm._m(0), _vm._v(" "), _c('metric-selector'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row community-selection-container"
  }, [_c('div', {
    staticClass: "col l7 s6"
  }, [_c('community-map')], 1), _vm._v(" "), _c('div', {
    staticClass: "col l5 s6"
  }, [_c('community-select-box')], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('results-list')], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [_c('sticky-legend')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 1: Select a Metric Category")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 2: Select Communities")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('h4', {
    staticClass: "center-align"
  }, [_vm._v("Step 3: View Metrics for Communities")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558fc388"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 146
// module chunks = 1